import { render, staticRenderFns } from "./ODTMadres.vue?vue&type=template&id=305866ce&scoped=true&"
import script from "./ODTMadres.vue?vue&type=script&lang=js&"
export * from "./ODTMadres.vue?vue&type=script&lang=js&"
import style0 from "./ODTMadres.vue?vue&type=style&index=0&id=305866ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305866ce",
  null
  
)

export default component.exports